import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onErrorStateSuggestedQueriesShown: ({
	showErrorStateSuggestedQueries,
	...props
}: commonAttributesType & {
	showErrorStateSuggestedQueries: string[];
}) => AnalyticsEventPayload = ({
	showErrorStateSuggestedQueries,
	...props
}: commonAttributesType & {
	showErrorStateSuggestedQueries: string[];
}): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'shown',
		actionSubject: 'aiErrorStateSuggestedQueries',
		source: source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
			showErrorStateSuggestedQueries,
		},
	};
};
